import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const RichTextEditor = () => {
  const [editorHtml, setEditorHtml] = useState("");

  const handleChange = (html) => {
    setEditorHtml(html);
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "video"],
      [{ align: [] }],
      ["clean"],
    ],
  };

  const editorStyles = {
    width: "100%", // Set the width to 100%
    margin: "auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    backgroundColor: "#fff",
  };

  const containerStyles = {
    border: "1px solid #ccc",
    borderRadius: "5px",
    minHeight: "200px",
    marginTop: "15px",
  };

  const renderedHtmlStyles = {
    marginTop: "20px",
    fontFamily: "Arial, sans-serif",
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: "#f8f8f8",
  };

  return (
    <div style={editorStyles}>
      <h6 style={{ textAlign: "start", color: "#333" }}>Plan Description :</h6>
      <ReactQuill
        theme="snow"
        value={editorHtml}
        onChange={handleChange}
        modules={modules}
        style={containerStyles}
      />

      <div style={renderedHtmlStyles}>
        <h6 style={{ color: "#333" }}>Display text:</h6>
        <div dangerouslySetInnerHTML={{ __html: editorHtml }} />
      </div>
    </div>
  );
};

export default RichTextEditor;
